module.exports = __webpack_public_path__ + "login-360fc939/energizer-8a21a7d8e3ec609336fc8b362b4119b2.jpeg";